// extracted by mini-css-extract-plugin
export default {"wrapper":"ui_wrapper__l8Jxd","wrapperLoader":"ui_wrapperLoader__mfP31","checkSignSuccess":"ui_checkSignSuccess__Rk50M"};